var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4934 17.9375L7.30469 14.7488L8.21841 13.8351L9.83716 15.4236V5.56806L8.22672 7.16494L7.313 6.25122L10.5017 3.0625L13.6904 6.25122L12.7684 7.18681L11.1494 5.57637V15.4236L12.7684 13.8351L13.6819 14.7488L10.4934 17.9375Z",
    fill: "#E4B713"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight2);
export default __webpack_public_path__ + "static/media/height_2.246443d0c4061047e5e511059cb2e4de.svg";
export { ForwardRef as ReactComponent };